import { createContext, useContext } from 'react'
import type { ManualItineraryDeleteRequest, ManualItineraryMoveRequest, TripItineraryData } from 'tripPlanner/api/types'
import type { ItineraryScrollTarget } from '../hooks/useItineraryUpdates'

export interface ItineraryContextValue {
  itineraryData: TripItineraryData | undefined
  hasItineraryData: boolean
  multiCartId: string | undefined
  enrichingStopIds: Set<number>
  enrichingItemIds: Set<number>
  scrollTarget: ItineraryScrollTarget | undefined
  clearScrollTarget: () => void
  refetchCurrentChatItinerary: () => void
  deleteManualItineraryTarget: (target: ManualItineraryDeleteRequest) => Promise<boolean>
  moveManualItineraryItems: (request: ManualItineraryMoveRequest) => Promise<boolean>
  isManualItineraryDeletePending: boolean
  isManualItineraryMovePending: boolean
  isFlightCartMutationPending: boolean
  setFlightCartMutationPending: (pending: boolean) => void
}

export const ItineraryContext = createContext<ItineraryContextValue | undefined>(undefined)

export function useItineraryContext(): ItineraryContextValue {
  const ctx = useContext(ItineraryContext)
  if (!ctx) throw new Error('useItineraryContext must be used within TripPlannerChatProvider')
  return ctx
}
